import { render, staticRenderFns } from "./MarketingDetails.vue?vue&type=template&id=e0f02c28"
import script from "./MarketingDetails.vue?vue&type=script&lang=js"
export * from "./MarketingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports